import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b76bc28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-footer" }
const _hoisted_2 = { class: "c-footer__wrapper c-grid" }
const _hoisted_3 = { class: "c-footer__nav" }
const _hoisted_4 = { class: "c-footer__nav" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, k) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(link.href ? 'a' : 'router-link'), {
            class: "c-footer__nav-link",
            key: 'footer-link-' + k,
            to: { name: link.to },
            href: link.href
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to", "href"]))
        }), 128))
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialLinks, (link, k) => {
          return (_openBlock(), _createElementBlock("a", {
            class: "c-footer__nav-link c-footer__nav-link--social",
            href: link.href,
            key: k,
            target: "_blank"
          }, [
            _createVNode(_component_Icon, {
              class: "c-footer__nav-icon",
              name: link.icon
            }, null, 8, ["name"])
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}